import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f12db4a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "SOLICITAR SERVIÇO", -1))

import { computed } from "vue";
import { useIonRouter } from "@ionic/vue";
import Button from "@/components/Button.vue";
import { arrowForwardOutline } from "ionicons/icons";
import { useUser } from "@/composables/user";
import { FirebaseAnalytics } from "@awesome-cordova-plugins/firebase-analytics";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardServices',
  props: {
    name: null,
    description: null,
    pending: null,
    amount: null,
    code: null
  },
  setup(__props: any) {

const props = __props as {
	name: string;
	description: string;
	pending?: any;
	amount: string;
	code: string;
}



const { user } = useUser();
const ionRouter = useIonRouter();

const openForm = async (code: string) => {
	let route;
	if (user.value?.activateService) {
		switch (code) {
			case "OPEN_MEI":
				route = "/create-mei";
				break;
			case "ANNUAL_STATEMENT":
				route = "/annual-statement";
				break;
			case "CHANGE_MEI":
				route = "/change-mei";
				break;
			case "LOW_MEI":
				route = "/low-mei";
				break;
			case "REGISTRATION_REGULARIZATION":
				route = "/registration-regularization";
				break;
		}

		if (
			!["OPEN_MEI", "REGISTRATION_REGULARIZATION"].includes(code) &&
			user.value &&
			!user.value.cnpj
		)
			return ionRouter.push(`/load-cnpj${route}`);

		await FirebaseAnalytics.logEvent("add_to_cart", {
			serviceName: props.name,
			serviceCode: props.code,
			path: route,
		});
		return ionRouter.push(route);
	} else {
		switch (code) {
			case "OPEN_MEI":
				return ionRouter.push("/create-mei-active");
			case "ANNUAL_STATEMENT":
				return ionRouter.push("/annual-statement-active");
			case "CHANGE_MEI":
				return ionRouter.push("/change-mei-active");
			case "LOW_MEI":
				return ionRouter.push("/low-mei-active");
			case "REGISTRATION_REGULARIZATION":
				return ionRouter.push("/regularization-cpf-active");
		}
	}
};

const openCnpjCondition = computed(() => {
	if (props.code === "OPEN_MEI" && user.value && user.value.cnpj)
		return false;
	else return true;
});

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_unref(openCnpjCondition))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.name), 1),
        _createElementVNode("p", null, _toDisplayString(__props.description), 1),
        _createVNode(Button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openForm(__props.code))),
          variant: "green"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_ion_icon, { icon: _unref(arrowForwardOutline) }, null, 8, ["icon"])
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})